import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyD90NMT_bXS8oK3XDgnAvxquPERKcHptFQ",
  authDomain: "serenity-path-c94ed.firebaseapp.com",
  projectId: "serenity-path-c94ed",
  storageBucket: "serenity-path-c94ed.firebasestorage.app",
  messagingSenderId: "553989028388",
  appId: "1:553989028388:web:0041072c870895ec9f76b1"
};

const app = initializeApp(firebaseConfig);

// (M4) App Check — binds Firestore/Storage/Auth access to this real app, blocking
// scripted abuse from outside it. Dormant until REACT_APP_RECAPTCHA_SITE_KEY is set
// (reCAPTCHA v3 site key from Firebase Console → App Check). Enforcement is toggled
// per-service in the console once tokens are flowing.
const APP_CHECK_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (APP_CHECK_KEY) {
  if (process.env.NODE_ENV !== "production" && typeof window !== "undefined") {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true; // lets localhost pass App Check in dev
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(APP_CHECK_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}
export const auth = getAuth(app);
export const db = getFirestore(app, "serenitypathmeditation");
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export default app;